import {Card, Popconfirm, Row, Switch, Table} from "antd";
import React, {useEffect} from "react";
import {SwitchContainer, UpdateButton} from "../SubcompanyCodPaymentSettings.styles";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../../../hooks/useStore";
import {useFormik} from "formik";
import moment from "moment";

export const CodPaymentSelfSelectionFeatureForm = ({
    subCompany,
    recall = () => {},
    hasFormVisibilityChange
}) => {
    const {t} = useTranslation();
    const stores = useStore();

    const codPaymentSelfSelectionFormik = useFormik({
        initialValues: {
            subCompanyId: subCompany?._id,
            vigoPOSSelfSelectionEnabled: Boolean(
                subCompany?.options?.codPayment?.vigoPOSSelfSelectionEnabled
            )
        },
        enableReinitialize: true,
        onSubmit: async values => {
            try {
                const payload = {
                    subCompanyId: values.subCompanyId,
                    vigoPOSSelfSelectionStatus: Boolean(values?.vigoPOSSelfSelectionEnabled)
                };

                const response = await stores.companyStore.updateSubCompanyCodPaymentMethodsSelfSelectionFeatureStatus(
                    {
                        ...payload
                    }
                );
                if (response) {
                    recall();
                }
            } catch (error) {
                console.error("Form validation failed:", error);
            }
        }
    });

    useEffect(() => {
        codPaymentSelfSelectionFormik.resetForm();
    }, [hasFormVisibilityChange]);

    return (
        <form onSubmit={codPaymentSelfSelectionFormik.handleSubmit}>
            <Card
                title="Ödeme Yöntemi Sözleşme Özelliği"
                //style={{minHeight: 200}}
            >
                <>
                    <div>
                        <SwitchContainer>
                            <div className="label">Sözleşme özelliği durumu</div>
                            <Switch
                                name="creditCard"
                                checked={
                                    codPaymentSelfSelectionFormik?.values
                                        ?.vigoPOSSelfSelectionEnabled
                                }
                                onChange={checked =>
                                    codPaymentSelfSelectionFormik.setFieldValue(
                                        "vigoPOSSelfSelectionEnabled",
                                        checked
                                    )
                                }
                            />
                        </SwitchContainer>
                        <Row justify="end" style={{marginTop: "24px"}}>
                            <Popconfirm
                                title={
                                    <>
                                        {codPaymentSelfSelectionFormik.values
                                            .vigoPOSSelfSelectionEnabled ? (
                                            <div style={{maxWidth: "500px"}}>
                                                <p>
                                                    Ödeme yöntemi seçim ve sözleşme özelliği aktif
                                                    hale getirilecektir.
                                                </p>
                                                <p>
                                                    Böylelikle, müşteri panelinde ödeme yöntemi
                                                    seçimi yapabilecektir.
                                                </p>
                                                <ul>
                                                    <li>
                                                        Kapıda ödeme yöntemini seçmesi durumunda,{" "}
                                                        <b>dijital sözleşme</b> oluşturulacaktır.
                                                    </li>
                                                    <li>
                                                        Dijital sözleşmede aşağıdaki bilgiler
                                                        kullanılacaktır.
                                                        <br />
                                                        <b>Lütfen kontrol ediniz.</b>
                                                    </li>
                                                </ul>
                                                <p>
                                                    <b> NOT:</b> Ödeme Dönemi ve komisyon oranı
                                                    belirlememeniz durumunda varsayılan olarak
                                                    <b>"Haftalık %2.9 komisyon"</b> seçilecektir.
                                                </p>
                                                <Table
                                                    pagination={false}
                                                    size="small"
                                                    key="property"
                                                    dataSource={[
                                                        {
                                                            property: "Müşteri Ünvanı",
                                                            status: subCompany?.bill
                                                                ?.commercialTitle || <b>Veri Yok</b>
                                                        },
                                                        {
                                                            property: "Tabela Adı",
                                                            status: subCompany?.bill
                                                                ?.commercialTitle || <b>Veri Yok</b>
                                                        },
                                                        {
                                                            property: "Firma Adres",
                                                            status: subCompany?.address || (
                                                                <b>Veri Yok</b>
                                                            )
                                                        },
                                                        {
                                                            property: "Firma Telefonu",
                                                            status: subCompany?.authorizedPhone || (
                                                                <b>Veri Yok</b>
                                                            )
                                                        },
                                                        {
                                                            property: "Firma Email",
                                                            status: subCompany?.authorizedEmail || (
                                                                <b>Veri Yok</b>
                                                            )
                                                        },
                                                        {
                                                            property: "Vergi No",
                                                            status: subCompany?.bill?.taxNumber || (
                                                                <b>Veri Yok</b>
                                                            )
                                                        },
                                                        {
                                                            property: "Vergi Dairesi",
                                                            status: subCompany?.bill
                                                                ?.registeredTaxOffice || (
                                                                <b>Veri Yok</b>
                                                            )
                                                        },
                                                        {
                                                            property: "T.C. Kimlik No",
                                                            status: subCompany?.authorizedID || (
                                                                <b>Veri Yok</b>
                                                            )
                                                        },
                                                        {
                                                            property: "Yetkili Ad Soyad",
                                                            status: subCompany?.authorizedPerson || (
                                                                <b>Veri Yok</b>
                                                            )
                                                        },
                                                        {
                                                            property: "Yetkili Telefon",
                                                            status: subCompany?.authorizedPhone || (
                                                                <b>Veri Yok</b>
                                                            )
                                                        },
                                                        {
                                                            property: "Hesap Ünvanı",
                                                            status: subCompany?.paymentInfo
                                                                ?.cashOnDelivery?.accountTitle || (
                                                                <b>Veri Yok</b>
                                                            )
                                                        },
                                                        {
                                                            property: "IBAN",
                                                            status: subCompany?.paymentInfo
                                                                ?.cashOnDelivery?.iban || (
                                                                <b>Veri Yok</b>
                                                            )
                                                        },
                                                        {
                                                            property: "Banka Adı",
                                                            status: subCompany?.paymentInfo
                                                                ?.cashOnDelivery?.bankName || (
                                                                <b>Veri Yok</b>
                                                            )
                                                        }
                                                    ]}
                                                >
                                                    <Table.Column
                                                        title="Alan"
                                                        dataIndex="property"
                                                    />
                                                    <Table.Column
                                                        title="Bilgi"
                                                        dataIndex="status"
                                                    />
                                                </Table>
                                            </div>
                                        ) : (
                                            <div>
                                                <p>
                                                    Ödeme yöntemi seçim ve sözleşme özelliği devre
                                                    dışı bırakılacaktır.
                                                </p>
                                            </div>
                                        )}
                                    </>
                                }
                                onConfirm={codPaymentSelfSelectionFormik.handleSubmit}
                                disabled={
                                    codPaymentSelfSelectionFormik.isSubmitting || !subCompany?._id
                                }
                                cancelText="İptal"
                                okText="Evet"
                            >
                                <UpdateButton
                                    disabled={
                                        codPaymentSelfSelectionFormik.isSubmitting ||
                                        !subCompany?._id
                                    }
                                >
                                    {codPaymentSelfSelectionFormik.isSubmitting
                                        ? "Güncelleniyor..."
                                        : "Güncelle"}
                                </UpdateButton>
                            </Popconfirm>
                        </Row>

                        {subCompany?.options?.codPayment?.vigoPOSSelfSelectionEnabled && (
                            <Row style={{marginTop: "24px"}}>
                                <Table
                                    showHeader={false}
                                    pagination={false}
                                    size="small"
                                    key="property"
                                    bordered
                                    style={{width: "100%"}}
                                    dataSource={[
                                        {
                                            property: "Seçim Yapılmış Mı",
                                            status: subCompany?.options?.codPayment
                                                ?.paymentMethodsSelfSelected
                                                ? "Evet"
                                                : "Hayır"
                                        },
                                        {
                                            property: "Seçim Tarihi",
                                            status: subCompany?.options?.codPayment
                                                ?.paymentMethodsSelectedAt
                                                ? moment(
                                                      subCompany?.options?.codPayment
                                                          ?.paymentMethodsSelectedAt
                                                  ).format("DD.MM.YYYY HH:mm")
                                                : "-"
                                        },
                                        {
                                            property: "Seçim Yapan Kişi",
                                            status: subCompany?.options?.codPayment
                                                ?.paymentMethodsSelectedBy?.fullName
                                                ? subCompany?.options?.codPayment
                                                      ?.paymentMethodsSelectedBy?.fullName
                                                : "-"
                                        },
                                        {
                                            property: "Seçim Yapan Kişi (E-Posta)",
                                            status: subCompany?.options?.codPayment
                                                ?.paymentMethodsSelectedBy?.email
                                                ? subCompany?.options?.codPayment
                                                      ?.paymentMethodsSelectedBy?.email
                                                : "-"
                                        },
                                        {
                                            property: "Seçim Yapan Kişi (Telefon)",
                                            status: subCompany?.options?.codPayment
                                                ?.paymentMethodsSelectedBy?.phone
                                                ? subCompany?.options?.codPayment
                                                      ?.paymentMethodsSelectedBy?.phone
                                                : "-"
                                        },
                                        {
                                            property: "Seçim Yapan Kişi (Kullanıcı Adı)",
                                            status: subCompany?.options?.codPayment
                                                ?.paymentMethodsSelectedBy?.username
                                                ? subCompany?.options?.codPayment
                                                      ?.paymentMethodsSelectedBy?.username
                                                : "-"
                                        }
                                    ]}
                                    columns={[
                                        {
                                            title: "",
                                            dataIndex: "property"
                                        },
                                        {
                                            title: "",
                                            dataIndex: "status"
                                        }
                                    ]}
                                />
                            </Row>
                        )}
                    </div>
                </>
            </Card>
        </form>
    );
};
